<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-menu offset-y>
		<template v-slot:activator="{ on: menuActivator }">
			<v-list-tile-action>
				<egranty-icon-button icon="feedback" color="orange" :disabled="assignmentNotAllowed"
					:label="getAssignmentButtonLabel" :menu-activator="menuActivator"
					for="assign-agency-projects-opinions-menu-assign-to-the-opinion"
					id="assign-agency-projects-opinions-menu-assign-to-the-opinion"/>
			</v-list-tile-action>
		</template>

		<v-list>
			<v-list-tile avatar @click="openAssignForSubstantiveEvaluationDialog(project)"
				:disabled="assignmentForSubstantiveEvaluationNotAllowed(project)">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii merytorycznej</v-list-tile-title>
			</v-list-tile>
			<v-list-tile avatar @click="openAssignForExpertDialog(project)"
				:disabled="assignmentForExpertEvaluationNotAllowed()">
				<v-list-tile-avatar>
					<v-icon color="orange">school</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii eksperta</v-list-tile-title>
			</v-list-tile>
			<v-list-tile avatar @click="openAssignForFinalEvaluationDialog(project)"
				:disabled="assignmentForFinalEvaluationNotAllowed(project)">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii końcowej</v-list-tile-title>
			</v-list-tile>
		</v-list>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForSubstantiveEvaluation.open"
			:select-items="dialogsState.assignForSubstantiveEvaluation.teamUsers"
			:validation-rules="[substantiveEvaluatorsValidationRule]"
			label="Członkowie zespołu do opinii"
			for="assign-agency-projects-opinions-menu-membership"
			id="assign-agency-projects-opinions-menu-membership"
			title="Przekazanie wniosku do opinii merytorycznej"
			field-type="SELECT_MANY"
			@save="assignSelectedProjectForSubstantiveEvaluation">
		</egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForFinalEvaluation.open"
			:select-items="dialogsState.assignForFinalEvaluation.teamUsers"
			label="Członkowie zespołu do opinii"
			for="assign-agency-projects-opinions-menu-membership2"
			id="assign-agency-projects-opinions-menu-membership2"
			title="Przekazanie wniosku do opinii końcowej"
			field-type="SELECT"
			@save="assignSelectedProjectForFinalEvaluation">
		</egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForExpert.open"
			:select-items="dialogsState.assignForExpert.experts"
			label="Eksperci do opiniowania"
			for="assign-agency-projects-opinions-experts-opinion"
			id="assign-agency-projects-opinions-menu-experts-opinion"
			title="Przekazanie wniosku do opinii ekspertów"
			field-type="SELECT_MANY"
			@save="assignSelectedProjectForExpert">
		</egranty-input-field-popup>
	</v-menu>
</template>
<script>
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";
	import {TeamUsers} from "@/api/generated/TeamUsers";
	import {AgencySubstantiveEvaluation} from "@/api/generated/AgencySubstantiveEvaluation";
	import {AgencyFinalEvaluation} from "@/api/generated/AgencyFinalEvaluation";
	import {AgencyExpertEvaluation} from "@/api/generated/AgencyExpertEvaluation";
	import {AgencyContest} from "@/api/generated/AgencyContest";

	export default {
		name: "AssignAgencyProjectsForOpinionsMenu",

		components: {EgrantyIconButton, EgrantyInputFieldPopup},

		data () {
			return {
				dialogsState: {
					assignForSubstantiveEvaluation: {
						open: false,
						teamUsers: [],
					},
					assignForFinalEvaluation: {
						open: false,
						teamUsers: [],
					},
					assignForExpert: {
						open: false,
						experts: [],
					},

					selectedProject: null,
				},
			};
		},

		computed: {
			assignmentNotAllowed () {
				return this.evaluationClosed || !this.project.teamId || this.project.agencyProjectStatus !== 'SUBMITTED';
			},

			getAssignmentButtonLabel () {
				if (this.evaluationClosed) {
					return 'Przydziel do opinii / oceny: (nieodpowiedni status ocen)';
				} else if (this.project.agencyProjectStatus !== 'SUBMITTED') {
					return 'Przydziel do opinii / oceny: (nieodpowiedni status wniosku)';
				} else if (!this.project.teamId) {
					return 'Przydziel do opinii / oceny (brak przypisania do zespołu)';
				} else {
					return 'Przydziel do opinii / oceny';
				}
			}
		},

		methods: {
			openAssignForSubstantiveEvaluationDialog (project) {
				if (this.assignmentForSubstantiveEvaluationNotAllowed(project)) return;
				this.dialogsState.selectedProject = project;
				TeamUsers.getTeamUsersAvailable(this, project.teamId,
					successResponse => {
						this.dialogsState.assignForSubstantiveEvaluation.teamUsers = successResponse
							.filter(tu => !project.substantiveEvaluations.some(e => e.teamUser.id === tu.id));
						this.dialogsState.assignForSubstantiveEvaluation.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy członków zespołu", errorResponse);
					});
			},

			openAssignForFinalEvaluationDialog (project) {
				if (this.assignmentForFinalEvaluationNotAllowed(project)) return;
				this.dialogsState.selectedProject = project;
				TeamUsers.getTeamUsersAvailable(this, project.teamId,
					successResponse => {
						this.dialogsState.assignForFinalEvaluation.teamUsers = project.finalEvaluation !== null ?
							successResponse.filter(user => user.id !== project.finalEvaluation.teamUser.id) :
							successResponse;
						this.dialogsState.assignForFinalEvaluation.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy członków zespołu", errorResponse);
					});
			},

			openAssignForExpertDialog (project) {
				if (this.assignmentForExpertEvaluationNotAllowed(project)) return;
				this.dialogsState.selectedProject = project;
				AgencyContest.getExperts(this, this.contestId,
					successResponse => {
						this.dialogsState.assignForExpert.experts = successResponse
							.filter(cu => !project.expertEvaluations.some(e => e.agencyContestUser.id === cu.id));
						// this.$emit("evaluation-assigned");
						this.dialogsState.assignForExpert.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy ekspertów", errorResponse);
					});
			},

			assignSelectedProjectForSubstantiveEvaluation (teamUsersIds) {
				AgencySubstantiveEvaluation.postTeamUsers(this, this.dialogsState.selectedProject.id, teamUsersIds,
					successResponse => {
						this.dialogsState.assignForSubstantiveEvaluation.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano członków zespołu", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać członków zespołu", errorResponse);
					});
			},

			assignSelectedProjectForFinalEvaluation (teamUserId) {
				AgencyFinalEvaluation.postTeamUser(this, this.dialogsState.selectedProject.id, teamUserId,
					successResponse => {
						this.dialogsState.assignForFinalEvaluation.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano członka zespołu", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać członka zespołu", errorResponse);
					});
			},

			assignSelectedProjectForExpert (expertIds) {
				AgencyExpertEvaluation.postContestUsers(this, this.dialogsState.selectedProject.id, expertIds,
					successResponse => {
						this.dialogsState.assignForExpert.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano ekspertów", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać ekspertów", errorResponse);
					});
			},

			substantiveEvaluatorsValidationRule (values) {
				let currentSize = this.project.substantiveEvaluations.length;
				if (values.length + currentSize > 3) {
					return "W ocenie może brać udział co najwyżej 3 członków zespołu";
				} else {
					return true;
				}
			},

			assignmentForSubstantiveEvaluationNotAllowed (project) {
				return !this.inclusionStatuses.individualEvaluationSchemaIncluded || project.substantiveEvaluations.length === 3;
			},

			assignmentForFinalEvaluationNotAllowed (project) {
				return project.finalEvaluation !== null || !this.inclusionStatuses.finalEvaluationSchemaIncluded;
			},

			assignmentForExpertEvaluationNotAllowed () {
				return !this.inclusionStatuses.expertEvaluationSchemaIncluded;
			}
		},

		props: {
			project: {
				type: Object, default: () => {
				}
			},
			contestId: {type: String},
			evaluationClosed: {type: Boolean, default: false},
			inclusionStatuses: {
				type: Object, default: () => {
					return {
						expertEvaluationSchemaIncluded: false,
						finalEvaluationSchemaIncluded: false,
						individualEvaluationSchemaIncluded: false
					};
				}
			}
		},
	};
</script>
